// Example usage:
// <div data-controller="tooltip" data-tippy-content="Hello world"></div>

import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";

export default class extends Controller {
  static values = {
    content: String
  }

  connect() {
    let options = {
      placement: 'top',
      arrow: true,
      animation: 'fade',
      theme: 'light-border',
      maxWidth: 250,
      duration: [200, 150],
      offset: [0, 8]
    }
    if (this.hasContentValue) {
      options['content'] = this.contentValue
    }
    this.tippy = tippy(this.element, options);
  }

  disconnect() {
    this.tippy.destroy();
  }
}
